import React, { useEffect, useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";

import Home from "./pages/Home";
import CreateFlow from "./pages/CreateFlow";
import Gracias from "./pages/Gracias";
import NotFound from "./pages/NotFound";
import AdminAccess from "./pages/admin/AdminAccess";
import { initializeMetaPixel, trackPixelEvent } from "./lib/metaPixel";
import { PAYMENTS_URL, TSHIRT_PRICE } from "./config/env";
import { useDispatch } from 'react-redux';
import { setUnitPrice } from './store/cartSlice';

const App = () => {
  const location = useLocation();
  const pageLocation = `${location.pathname}${location.search}`;
  const dispatch = useDispatch();
  const [configLoaded, setConfigLoaded] = useState(false);

  useEffect(() => {
    let cancelled = false;
    fetch(`${PAYMENTS_URL}?action=storefront_config`)
      .then((response) => response.ok ? response.json() : null)
      .then((data) => {
        if (cancelled || !data?.ok) return;
        const price = Number(data.precio_remera);
        dispatch(setUnitPrice(Number.isFinite(price) && price > 0 ? price : TSHIRT_PRICE));
        if (data.pixel_id) initializeMetaPixel(data.pixel_id);
      })
      .catch(() => {})
      .finally(() => { if (!cancelled) setConfigLoaded(true); });
    return () => { cancelled = true; };
  }, [dispatch]);

  useEffect(() => {
    // In an SPA, count the visible route after server configuration loads.
    if (configLoaded && !location.pathname.startsWith('/admin')) {
      trackPixelEvent('PageView');
    }
  }, [pageLocation, location.pathname, configLoaded]);

  return (
    <AnimatePresence exitBeforeEnter>
      <Routes location={location} key={`${location.pathname}${location.search}`}>
        <Route path="/" element={<Home />} />
        <Route path="/crear" element={<CreateFlow />} />
        <Route path="/gracias" element={<Gracias />} />
        <Route path="/admin-pedidos" element={<AdminAccess />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </AnimatePresence>
  );
};

export default App;
